import { AutoFixHigh, ContentCut } from '@mui/icons-material';
import { CircularProgress, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { EditorTool } from './types';

type EditorToolbarProperties = {
  activeTool: EditorTool;
  onToolChange: (tool: EditorTool) => void;
  isSegmenting: boolean;
};

type TopTab = 'autoSegment' | 'manualCrop';

const toolToTab = (tool: EditorTool): TopTab => (tool === 'segment' ? 'autoSegment' : 'manualCrop');

export const EditorToolbar = ({ activeTool, onToolChange, isSegmenting }: EditorToolbarProperties) => {
  const activeTab = toolToTab(activeTool);

  const handleTabChange = (_: React.MouseEvent<HTMLElement>, newTab: TopTab | null) => {
    if (!newTab) return;
    if (newTab === 'autoSegment') {
      onToolChange('segment');
    } else {
      onToolChange('smartCrop');
    }
  };

  return (
    <ToggleButtonGroup
      value={activeTab}
      exclusive
      onChange={handleTabChange}
      size='small'
      sx={{ '& .MuiToggleButton-root': { textTransform: 'none', gap: 0.5, px: 1.5 } }}
    >
      <ToggleButton value='autoSegment'>
        {isSegmenting ? <CircularProgress size={18} /> : <AutoFixHigh sx={{ fontSize: 18 }} />}
        Auto Segment
      </ToggleButton>
      <ToggleButton value='manualCrop'>
        <ContentCut sx={{ fontSize: 18 }} />
        Manual Crop
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
